import ShellSelectRama2Building from "assets/pages/Dashboard/BuildingImage/ShellSelectNamrungruang.svg";
// import styled, { keyframes } from "styled-components";
// import { Tooltip } from "components/Common/Tooltip/Tooltip";

export const ShellRama2 = () => {
  return <img src={ShellSelectRama2Building} />;
};
